import { Component, OnInit } from '@angular/core';
import { ButtonStateType } from 'app/shared/button/button.component'

@Component({
    selector: 'sbw-button-demo',
    templateUrl: './button-demo.component.html'
})
export class ButtonDemoComponent implements OnInit {

    public buttonState: ButtonStateType = 'activated'
    
    public buttonClicked(e) {
        console.log('buttonClicked', e);

        setTimeout(() => { this.buttonState = 'activated' }, 2000)
    }
    constructor() { }

    ngOnInit() {
    }

}
